export const APP_VERSION = "1.0.10.";

export const userAccessTokenName = "PORTALUAT";

export const paginationDefaultItemCount = 10;